import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthComponent } from './layouts/auth/auth.component';
import { extraPagesComponent } from './layouts/extra-pages/extra-pages.component';

export const routes: Routes = [
    {   
        path: 'payment', 
        component: AuthComponent,
        loadChildren: () => import('../app/resources/payment/payment.module').then(m => m.PaymentModule)
    },
    {   
        path: "**", 
        component: extraPagesComponent, 
        loadChildren: () =>
            import("./resources/extrapages/extrapages.module").then((m) => m.ExtrapagesModule),
    }
];
